import dayjs from 'dayjs';
import { DateBoundFn } from '@restavo/crud';

/**
 * The portal's half of the date filter seam: dayjs day-bounds in the app's locale
 * (spec §7.2's date note). `on` expands to the whole local day for the server's $between;
 * `before` bounds at start-of-day and `after` at end-of-day, so "before the 5th" and
 * "after the 5th" both exclude the 5th itself. An unparseable value returns null, which
 * compileFilter turns into a dropped chip.
 */
export const portalDateBound: DateBoundFn = (value, kind) => {
  const d = dayjs(value);
  if (!d.isValid()) {
    return null;
  }
  if (kind === 'on') {
    return { from: d.startOf('day').toISOString(), to: d.endOf('day').toISOString() };
  }
  if (kind === 'before') {
    return { from: d.startOf('day').toISOString(), to: d.startOf('day').toISOString() };
  }
  return { from: d.endOf('day').toISOString(), to: d.endOf('day').toISOString() };
};
